// extracted by mini-css-extract-plugin
export default {"card-list-wrap":"index_card-list-wrap__0wYDz"};